import { useLocation } from 'react-router-dom';
import { useAppShellPlatform } from './useAppShellPlatform';
import { findSiblingGroup } from '../constants/siblingGroups';

/**
 * SF-181 Component 5: whether `MobileTabBar` is currently rendered — the union of
 * `AppShellLayout`'s 5 fixed hub routes and `Layout`'s `findSiblingGroup`-matched sibling routes,
 * mirroring the exact rule each layout already encodes independently (neither exposes it as a
 * standalone boolean a third consumer like `ToastContainer` could reuse).
 */
const APP_SHELL_HUB_ROUTES = new Set(['/province', '/realm', '/war', '/kingdom', '/world']);

export function useMobileTabBarPresent(): boolean {
  const platform = useAppShellPlatform();
  const { pathname } = useLocation();
  if (platform !== 'mobile') return false;
  return APP_SHELL_HUB_ROUTES.has(pathname) || findSiblingGroup(pathname) !== undefined;
}
